import { render, staticRenderFns } from "./CoparateCongratulation.vue?vue&type=template&id=346d9516"
import script from "./CoparateCongratulation.vue?vue&type=script&lang=js"
export * from "./CoparateCongratulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports